// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4015":"4fd51ba3","8220":"4fd51ba3"}[chunkId] + ".chunk.css";
};